(function (window, document) {
  if (window.boatWidget) {
    console.error("Boat widget embed already included");
    return;
  }
  (window.boatWidget = {}), (m = ["init", "login", "signup", "setAttribute", "getCurrentUser", "logout", "debug"]);
  window.boatWidget._c = [];
  m.forEach(
    (me) =>
      (window.boatWidget[me] = function () {
        console.log("boat widget called", me, arguments);
        window.boatWidget._c.push([me, arguments]);

        if (me === "init") {
          if(arguments.length != 3) {
            console.error("init must be called with 4 arguments: clientId, divId, url, brandId"); // Ahoy Club
          }
          var elt = document.createElement("script");
          elt.type = "text/javascript";
          elt.async = true;
          elt.src = arguments[2] + "/build/frontend/widget/shim.js";
          var before = document.getElementsByTagName("script")[0];
          before.parentNode.insertBefore(elt, before);
        }
      })
  );
})(window, document, undefined);

